import React, { useEffect } from 'react';

const Footer = () => {
  // Añadir año actual dinámicamente
  useEffect(() => {
    const yearSpan = document.querySelector('.current-year');
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear();
    }
  }, []);

  return (
    <footer className="position-relative pt-6 pt-md-8 pt-lg-10 pt-xl-12 bg-dark">
      <div className="container z-index-9 position-relative">
        <div className="row mt-n5 pb-6 pb-md-8 pb-lg-10 pb-xl-12">
          <div className="col-lg-6 mt-5">
            <h2 className="text-white w-90 display-4 font-weight-800 mb-0 lh-1">Productos de decoración</h2>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-sm-6 mt-5">
                <div className="sec-title pb-4">
                  <h3 className="text-white">Dirección</h3>
                </div>
                <address className="mb-0 display-29 display-md-28 display-xl-27">
                  CDMX — <br />Pte. 118 No. 333-A,<br />Col. Capultitlán, CDMX, C.P. 07370 Del. G.A.M. México
                </address>
              </div>
              <div className="col-sm-6 mt-5 text-sm-end">
                <div className="sec-title pb-4">
                  <h3 className="text-white">Contáctanos</h3>
                </div>
                <p className="phone">
                  <a href="tel:+525596273546" className="display-26 display-md-25 display-xl-24">
                    55 96 27 35 46
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-top border-color-light-white z-index-9 position-relative">
        <div className="container">
          <div className="row align-items-center py-4">
            <div className="col-md-7 col-lg-6 text-center text-md-start order-2 order-md-1">
              <p className="d-inline-block text-white mb-0">
                &copy; <span className="current-year"></span> Todos los derechos reservados{' '}
                <a href="https://www.nacid.net" className="text-primary text-white-hover">
                  Nacid Marketing
                </a>
              </p>
            </div>
            <div className="col-md-5 col-lg-6 text-center text-md-end mb-3 mb-md-0 order-1 order-md-2">
              <ul className="social-icon-style1 mb-0 d-inline-block list-unstyled">
                <li className="d-inline-block me-3">
                  <a
                    href="https://www.facebook.com/share/WeCwXfhK7VGCb6JW/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                {/* Otros íconos comentados */}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Estilos personalizados para el botón de Facebook */}
      <style>{`
        .social-icon-facebook {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          background-color: #1877f2;
          color: white;
          border-radius: 50%;
          transition: all 0.3s ease;
          text-decoration: none;
          font-size: 22px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.2);
        }
        .social-icon-facebook:hover {
          background-color: #0c5bd0;
          transform: scale(1.05);
          box-shadow: 0 6px 14px rgba(0,0,0,0.25);
        }
        /* Asegurar que el ícono interno herede el color y tamaño */
        .social-icon-facebook i {
          color: inherit;
          font-size: inherit;
        }
        /* Responsive: ajustar tamaño en móviles */
        @media (max-width: 768px) {
          .social-icon-facebook {
            width: 60px;
            height: 60px;
            font-size: 50px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;